import { TextField } from '@mui/material';
import styled from 'styled-components';

export const StyledClauseTextField = styled(TextField)`
    border-radius: 3px;
    input {
        font-size: 14px;
    }
    fieldset {
        border: none;
        border-radius: 8px;
    }
`;
